/**
 * Vuex getters for the department module.
 *
 * @module store/modules/department/getters
 */
import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { DepartmentState } from "./types";

const getters: GetterTree<DepartmentState, RootState> = {
  /**
   * Gets the department creation loading state.
   *
   * @param {DepartmentState} state - Module state
   * @returns {boolean} Loading flag
   */
  createDepartmentLoading(state, getters, rootState) {
    return state.createLoading;
  },
};

export default getters;
